import { render, staticRenderFns } from "./BatchAdjustmentOrderDialog.vue?vue&type=template&id=18bfbe02&scoped=true"
import script from "./BatchAdjustmentOrderDialog.vue?vue&type=script&lang=js"
export * from "./BatchAdjustmentOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bfbe02",
  null
  
)

export default component.exports